import React from "react";
import {getSyncEngineVersion} from "../../../../common/helpers/syncEngine";
import PaymentV1 from "../../LogV1/payment";
import PaymentV2 from "../../LogV2/payment";

const Payment: React.FC = () => {
    return getSyncEngineVersion() === 'v2' ? <PaymentV2 /> : <PaymentV1 />;
};

export default Payment;
